import { render, staticRenderFns } from "./PxCriterioProjeto.vue?vue&type=template&id=2fcf909a&"
import script from "./PxCriterioProjeto.vue?vue&type=script&lang=js&"
export * from "./PxCriterioProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports